import { CommonModule } from '@angular/common';
import { Component, OnInit, signal, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AnimatedTimerComponent } from '@app/shared/components/animated-timer/animated-timer.component';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { WalletComponent } from '@app/shared/components/wallet/wallet.component';
import { ParagraphComponent } from '@app/shared/components/text/p/p.component';
import { LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { Modal, ModalType } from '@app/shared/models/modal.model';
import { Wallet } from '@app/shared/models/wallet.model';
import { LimitedTimeEventService } from '@app/shared/services/limitedTimeEvent.service';
import { LoggerService } from '@app/shared/services/logger.service';
import { SharedModule } from '@app/shared/shared.module';
import { WalletRepository } from '@app/shared/state/wallet/wallet.repository';
import { EventManager } from '@app/shared/utils/event-manager';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs';

@Component({
  selector: 'slotcom-complete-with-gems',
  templateUrl: './complete-with-gems.component.html',
  styleUrls: ['./complete-with-gems.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ParagraphComponent,
    ButtonComponent,
    WalletComponent,
    AnimatedTimerComponent,
    SharedModule,
  ],
})
export class CompleteWithGemsComponent implements OnInit {
  completeWithGemsModalData = inject<Modal>(MAT_DIALOG_DATA);
  private translateService = inject(TranslateService);
  private walletRepo = inject(WalletRepository);
  private eventManager = inject(EventManager);
  logger = inject(LoggerService);
  private limitedTimeEventService = inject(LimitedTimeEventService);
  private dialog = inject(MatDialog);

  confirmationText: string;
  loading = signal(false);

  get wallet(): Wallet {
    return this.walletRepo.getWallet();
  }

  ngOnInit(): void {
    this.confirmationText = this.translateService.instant('home.daily-challenge.complete-with-gems.confirmation', {
      x: this.completeWithGemsModalData.data.challenge.gemsToComplete.toString(),
    });
  }

  completeChallenge() {
    this.loading.set(true);
    this.limitedTimeEventService
      .completeChallengeSpendingGems(
        this.completeWithGemsModalData.data.dailyChallenge.eventId,
        this.completeWithGemsModalData.data.challenge.id
      )
      .pipe(finalize(() => this.loading.set(false)))
      .subscribe({
        next: (event: LimitedTimeEvent) => {
          if (event) {
            this.limitedTimeEventService.updateLimitedTimeEventById(event);
            this.eventManager.completedDCWithGems();
            this.closeModal();
          }
        },
        error: (err) => this.logger.error(err),
      });
  }

  closeModal() {
    if (this.dialog.getDialogById(this.completeWithGemsModalData.id)) {
      this.eventManager.closeModal(
        new Modal(this.completeWithGemsModalData.id, ModalType.View, this.completeWithGemsModalData)
      );
    }
  }
}
